import Reveal from '../../components/Reveal/Reveal';
import { MERCHANDISING, PACKAGES } from '../../app.const';

function Packages() {
  return (
    <div className="Packages container">
      <div className="Packages-intro-block grid">
        <div className="col-7">
          <p className="Eyebrow">Packages</p>
          <h1>Curated collections, not inventory.</h1>
          <p className="Packages-intro">{MERCHANDISING.intro}</p>
        </div>
        <div className="col-5">
          <div className="Packages-philosophy-block">
            <span className="Packages-philosophy-mark" aria-hidden="true">“</span>
            <p className="Packages-philosophy">{MERCHANDISING.philosophy}</p>
          </div>
        </div>
      </div>

      <Reveal as="section" className="u-promise">
        <p>{MERCHANDISING.finalExperience}</p>
      </Reveal>

      <div className="Packages-list">
        {PACKAGES.map((pkg, index) => (
          <Reveal as="section" className="Packages-item" id={pkg.id} key={pkg.id}>
            <div className="grid">
              <div className="col-5">
                <span className="Editorial-index">{String(index + 1).padStart(2, '0')}</span>
                <h2>{pkg.name}</h2>
                {pkg.subtitle && <p className="Packages-subtitle">{pkg.subtitle}</p>}
                {pkg.focus && <p className="Packages-focus">{pkg.focus}</p>}
              </div>

              <div className="col-7">
                {pkg.categories.map((category) => (
                  <div className="Packages-detail" key={category.group || 'categories'}>
                    <p className="Packages-detail-label">{category.group || 'Categories'}</p>
                    <div className="Packages-pill-row">
                      {category.items.map((item) => (
                        <span className="Packages-pill" key={item}>
                          {item}
                        </span>
                      ))}
                    </div>
                  </div>
                ))}

                {pkg.designedFor && (
                  <div className="Packages-detail">
                    <p className="Packages-detail-label">Designed for</p>
                    <div className="Packages-pill-row">
                      {pkg.designedFor.map((place) => (
                        <span className="Packages-pill" key={place}>
                          {place}
                        </span>
                      ))}
                    </div>
                  </div>
                )}

                {pkg.notes && (
                  <div className="Packages-detail">
                    <p className="Packages-detail-label">{pkg.notes.label}</p>
                    <ul className="Packages-notes-list">
                      {pkg.notes.items.map((item) => (
                        <li key={item}>{item}</li>
                      ))}
                    </ul>
                  </div>
                )}

                {pkg.closing && <p className="Packages-closing">{pkg.closing}</p>}
              </div>
            </div>
          </Reveal>
        ))}
      </div>

  
    </div>
  );
}

export default Packages;
